import React, { forwardRef } from "react";
import { Box, BoxProps, useTheme } from "@mui/material";

type ParentProps = {
  children: React.ReactNode;
  picturePath: string | undefined;
  isPreferred: boolean;
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
};

export const LocationStyledContainer: React.FC<ParentProps> = forwardRef<
  HTMLDivElement,
  ParentProps
>(({ children, picturePath, isPreferred, onClick }, ref) => {
  return (
    <LocationStyledParentBox
      ref={ref}
      onClick={onClick}
      data-testid="location-card-container-parent-box"
      picturepath={picturePath}
      ispreferred={isPreferred}
    >
      {children}
    </LocationStyledParentBox>
  );
});

export const LocationStyledContainer2: React.FC<ParentProps> = ({
  children,
  picturePath,
  isPreferred,
  onClick
}) => {
  return (
    <LocationStyledParentBox
      onClick={onClick}
      data-testid="location-card-container-parent-box"
      picturepath={picturePath}
      ispreferred={isPreferred}
    >
      {children}
    </LocationStyledParentBox>
  );
};

interface LocationStyledParentBoxProps extends BoxProps {
  picturepath?: string;
  ispreferred: boolean;
  children?: React.ReactNode;
}

export const LocationStyledParentBox = forwardRef<HTMLDivElement, LocationStyledParentBoxProps>(
  ({ picturepath, ispreferred, children, sx, ...rest }, ref) => {
    const theme = useTheme();

    const backgroundImage = picturepath
      ? `linear-gradient(${theme.palette.background.paper}, ${theme.palette.background.paper}00 120%), url(${picturepath})`
      : "none"; // opacity value was 120%

    return (
      <Box
        ref={ref}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "column",
          borderRadius: 3,
          cursor: ispreferred ? "pointer" : "auto",
          background: theme.palette.background.paper,
          backgroundImage: backgroundImage,
          backgroundColor: theme.palette.background.paper,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          width: 400,
          height: 193,
          ...sx
        }}
        {...rest}
      >
        {children}
      </Box>
    );
  }
);

export const LocationStyledBodyBox: React.FC<BoxProps> = ({ children, sx, ...rest }) => {
  return (
    <Box
      component="div"
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        textAlign: "left",
        fontSize: "inherit",
        height: "100%",
        cursor: "pointer",
        ...sx
      }}
      {...rest}
    >
      {children}
    </Box>
  );
};
